import { Icon, i18n, Form, Input, Row, utils, http, Image } from '@common';
import { useRef, useState, useEffect, useCallback, useMemo } from "react";
import { CISInput } from '../input/input';
import { setCookie, getCookie } from '../../utils/utils';
import LodingButton from '../lodingButton/index';
import { baseService, emailOTPService, accountService } from '@api';
import './index.less';
const ChangePassword = (props) => {
    const formRef = useRef();
    const emailRef = useRef();
    const [password, setPassword] = useState({});
    const params = utils.geturlparam(props?.location.search);
    const { sub = '' } = params.obj;
    let initTimer = 60;
    const [isResendIn, setIsResendIn] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isResend, setIsResend] = useState(false);
    const [isPasswordValidate, setIsPasswordValidate] = useState({ status: false });
    // eslint-disable-next-line no-unused-vars
    const [times, setTimes] = useState(0);
    const [timer, setTimer] = useState(initTimer);
    const [verifyTime, setVerifyTime] = useState(0);
    const [loginDisabled, setLogindisabled] = useState(true);
    const [btnIsDisable, setBtnIsDisable] = useState(false);
    const [cookieDisable, setCookieDisable] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);
    const [isSendOTP, setIsSendOTP] = useState(false);
    const checkCookie = getCookie('disablebtn');
    const [verifyData, setVerifyData] = useState({});

    const getVerificationPhoto = async (data = {}) => {
        const parma = { "Adjustment": 0 };
        await baseService.getVerificationPhoto(parma).then((res) => {
            setVerifyData({ ...verifyData, ...data, photo: res?.detail[1], id: res?.detail[0], successStatus: false, code: '' });
        }).catch(e => {
            throw e;
        });
    };

    useEffect(() => {
        isFirstPage && getVerificationPhoto();
    }, [isFirstPage]);


    useEffect(() => {
        if (loginDisabled && btnIsDisable) setCookieDisable(true);
    }, [btnIsDisable, loginDisabled]);

    useEffect(() => {
        if (checkCookie) {
            setBtnIsDisable(true);
            setIsDisabled(true);
        } else {
            setBtnIsDisable(false);
            setLogindisabled(false);
        }
    }, [checkCookie]);
    const login = useCallback((e) => {
        const enterPasswordInput = document.querySelector('.re-enter-password')?.querySelector('#reEnterPassword');
        const otpInput = document.querySelector('.login-by-otp')?.querySelector('#inputOtp');
        let timer = null;
        if (timer) { clearTimeout(timer); }
        timer = setTimeout(() => {
            if (e.key === 'Enter' && otpInput && otpInput === document.activeElement && isFirstPage) {
                setPassword(inputItem => {
                    password.email = inputItem.email;
                    password.otpCode = inputItem.otpCode;
                    password.userName = inputItem.userName || decodeURIComponent(sub);
                    return inputItem;
                });
                setVerifyData(inputItem => {
                    verifyData.code = inputItem?.code || verifyData?.code;
                    verifyData.id = inputItem.id;
                    verifyData.photo = inputItem.photo;
                });

                if (!loginDisabled && e.key === 'Enter') {
                    otpInput?.blur();
                    handleLogin(isFirstPage);
                }
            } else if (e.key === 'Enter' && enterPasswordInput && enterPasswordInput === document.activeElement && !isFirstPage) {
                setPassword(inputItem => {
                    password.reEnterPassword = inputItem.reEnterPassword;
                    password.enterPassword = inputItem.enterPassword;
                    return inputItem;
                });
                if (!loginDisabled && e.key === 'Enter') {
                    enterPasswordInput?.blur();
                    handleLogin(isFirstPage);
                }
            }

        }, 200);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginDisabled, isFirstPage, verifyData, password]);

    useEffect(() => {
        document.addEventListener('keyup', login);

        return () => {
            document.removeEventListener("keyup", login);
        };

    }, [loginDisabled, isFirstPage, login]);

    const handleSendCode = useCallback(() => {
        $$.loading(true);
        const param = {
            photoId: verifyData.id,
            ans: verifyData.code,
            userId: password.userName || decodeURIComponent(sub),
            forRetrieve: true,
        };
        baseService.checkCaptchaAndStudentId(param).then(res => {
            setIsSendOTP(true);
            sendOTP();
            setIsPasswordValidate({ ...isPasswordValidate, emailStatus: false });
            $$.toast(i18n.get('CIS_Home_EmailOTP_Sendcode_Success_Message'));
        }).catch(err => {
            if (err?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.toast(i18n.get('CIS_Home_EmailOTP_Sendcode_Same_Message'), 'error');
            } else if (err?.errorCode === http.ErrorCode.SchemaInvalid) {
                setVerifyData({ ...verifyData, errorStatus: false });
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: true, otpStatus: false, emailStatus: true, message: err.message });
            } else if (err.errorCode === http.ErrorCode.InvalidInput || err.errorCode === http.ErrorCode.CodeError) {
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: false });
                const data = { ...verifyData, errorStatus: true, message: err.message };
                setVerifyData(data);
                getVerificationPhoto(data);
            }
            throw err;
        }).finally(() => {
            $$.loading(false);
        });
    }, [getVerificationPhoto, isPasswordValidate, password?.email, password.userName, sendOTP, sub, verifyData]);

    const sendOTP = useCallback(() => {
        setLogindisabled(false);
        setTimes((prevCount) => {
            if (prevCount > 2) {
                setCookie('disablebtn', true, 60);
                setIsDisabled(true);
            }
            return prevCount + 1;
        });
        setVerifyTime(0);
        setIsResendIn(false);
        const auth_timer = setInterval(() => {
            setTimer((prevCount) => {
                if (prevCount > 0) {
                    return prevCount - 1;
                } else {
                    setIsResendIn(true);
                    setIsResend(true);
                    setTimer(60);
                }
                clearInterval(auth_timer);
            });
        }, 1000);
    }, []);

    const handleInputChange = (type, value) => {
        switch (type) {
            case 'enter':
                setPassword({ ...password, enterPassword: value });
                break;
            case 'reEnter':
                setPassword({ ...password, reEnterPassword: value });
                break;
            case 'email':
                setPassword({ ...password, email: value });
                break;
            case 'otp':
                setPassword({ ...password, otpCode: value });
                break;
            case 'username':
                setPassword({ ...password, userName: value });
                break;
            case 'verify':
                setVerifyData({ ...verifyData, code: value });
                break;
        }
    };

    const loginButtonText = useMemo(() => {
        if (cookieDisable && isFirstPage) {
            return i18n.get('CIS_Home_EmailOTP_BlockSendOTP_Entry');
        }
        if (loginDisabled && isFirstPage) {
            return i18n.get('CIS_Home_EmailOTP_Entercode_Error_Manytimes_Entry');
        }
        return isFirstPage ? i18n.get('CIS_ChangePassword_NextButton_Entry') : i18n.get('CIS_ChangePassword_SaveButton_Entry');
    }, [cookieDisable, isFirstPage, loginDisabled]);

    const handleLogin = (isFirstPage) => {
        if (isFirstPage) {
            $$.loading(true);
            const objs = {
                UserId: password.userName || decodeURIComponent(sub) || '',
                OtpCode: password.otpCode || '',
            };
            baseService.checkEmailOtpCode(objs).then(res => {
                setIsFirstPage(false);
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: false, otpStatus: false, emailStatus: false, tokenId: res.detail });
            }).catch(e => {
                if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                    setIsPasswordValidate({ ...isPasswordValidate, otpStatus: true, emailStatus: false, message: e.message });
                    if (verifyTime < 2) {
                        setVerifyTime(verifyTime + 1);
                    } else {
                        setLogindisabled(true);
                    }
                } else if (e?.errorCode === http.ErrorCode.InvalidInput) {
                    setIsPasswordValidate({ ...isPasswordValidate, emailStatus: true, otpStatus: false, message: e.message });
                } else if (e?.errorCode === http.ErrorCode.ResourceNotExist) {
                    setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: true, otpStatus: false, emailStatus: false, message: e.message });
                } else if (e?.errorCode === http.ErrorCode.Required) {
                    setIsPasswordValidate({ ...isPasswordValidate, emailStatus: true, userNameStatus: true, otpStatus: false, message: e.message });
                }
                getVerificationPhoto();

            }).finally(() => {
                setVerifyData({ ...verifyData, errorStatus: false, successStatus: false });
                $$.loading(false);
            });
        } else {
            if (!password.enterPassword || !password.reEnterPassword) {
                setIsPasswordValidate({ ...isPasswordValidate, firstStatus: true, secondStatus: true, message: i18n.get('CIS_ChangePassword_EnterOrReenterIsNull_Message') });
            } else if (password.enterPassword !== password.reEnterPassword) {
                setIsPasswordValidate({ ...isPasswordValidate, firstStatus: false, secondStatus: true, message: i18n.get('CIS_ChangePassword_EnterAndReenterNotequality_Message') });
            } else {
                const objs = {
                    UserId: password.userName || decodeURIComponent(sub) || '',
                    NewPassword: encodeURIComponent(password.enterPassword) || '',
                    TokenId: isPasswordValidate.tokenId || ''
                };

                $$.loading(true);
                baseService.changePassword(objs).then((res) => {
                    setIsPasswordValidate({ ...isPasswordValidate, firstStatus: false, secondStatus: false });
                    $$.messagebox(true, {
                        title: i18n.get('CIS_ChangePassword_Success_Title_Entry'),
                        content: (
                            <div className='text-center'>
                                <img src={Image.success_green} alt="img" width={98} height={98} />
                                <div>
                                    {i18n.get('CIS_ChangePassword_Success_Content_Entry')}
                                </div>
                                <R.Button
                                    className="margin-top-l"
                                    classify="theme"
                                    onClick={handleConfirm}
                                    text={i18n.get('CIS_ChangePassword_Success_Button_Entry')}
                                />
                            </div>
                        ),
                    });
                }).catch(e => {
                    if (e?.errorCode === http.ErrorCode.CodeError || e?.errorCode === http.ErrorCode.CatchErrorCode) {
                        setIsPasswordValidate({ ...isPasswordValidate, firstStatus: true, secondStatus: false, message: e.message });
                    }
                }).finally(() => {
                    $$.loading(false);
                });
            }
        }
    };
    const handleConfirm = () => {
        Promise.all([
            accountService.logout(),
            accountService.regoLogin(`${utils.getOriginUrl()}/student`),
            accountService.logoutIDP()
        ]).then(([logout, regoLogin, logoutidp]) => {
            $$.loading(false);
            const redirectTo = `${logout.detail}?redirect_uri=${encodeURIComponent(logoutidp?.detail ? logoutidp?.detail : regoLogin?.detail)}`;
            utils.redirectTo(redirectTo);
        }).catch(e => {
            $$.loading(false);
            utils.redirectTo('/student');
            throw e;
        });
    };

    const handleBack = () => {
        setIsPasswordValidate({ ...isPasswordValidate, firstStatus: false, secondStatus: false });
        setPassword({ ...password, otpCode: null });
        setIsFirstPage(true);
    };

    const emailHide = (email) => {
        if (!email) return '';
        let preEmail = email.split('@')[0];
        let cutEmail = preEmail.slice(2);
        return email.replace(cutEmail, '*****');
    };

    const refreshClick = () => {
        getVerificationPhoto();
    };
    const changepasswordInputBlur = (e) => {
        if (!password.enterPassword || !password.reEnterPassword) {
            setIsPasswordValidate({ ...isPasswordValidate, firstStatus: true, secondStatus: true, message: i18n.get('CIS_ChangePassword_EnterOrReenterIsNull_Message') });
        } else if (password.enterPassword !== password.reEnterPassword) {
            setIsPasswordValidate({ ...isPasswordValidate, firstStatus: false, secondStatus: true, message: i18n.get('CIS_ChangePassword_EnterAndReenterNotequality_Message') });
        }
        else {
            const objs = {
                NewPassword: encodeURIComponent(password.enterPassword) || ''
            };
            baseService.checkPassword(objs).then(res => {
                setIsPasswordValidate({ ...isPasswordValidate, firstStatus: false, secondStatus: false });
            }).catch(e => {
                if (e?.errorCode === http.ErrorCode.CodeError || e?.errorCode === http.ErrorCode.CatchErrorCode) {
                    setIsPasswordValidate({ ...isPasswordValidate, firstStatus: true, secondStatus: false, message: e.message });
                }
            });
        }
    };
    const userNameInputBlur = (e) => {
        if (password.userName || sub) {
            setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: false });
        }
    };
    const checkCaptchaCode = () => {
        if (!verifyData.code) {
            setVerifyData({ ...verifyData, errorStatus: true, successStatus: false, message: i18n.get('CIS_HumanVerification_Input_Null_Entry') });
            return;
        }
        $$.loading(true);
        const objs = {
            studentId: password.userName || decodeURIComponent(sub) || '',
            id: verifyData.id,
            ans: verifyData.code
        };
        baseService.checkCaptchaVerification(objs).then(res => {
            setVerifyData({ ...verifyData, errorStatus: false, successStatus: true });
            setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: false, otpStatus: false });
            setPassword({ ...password, email: res.detail });
        }).catch(e => {
            if (e.errorCode === http.ErrorCode.Duplication) {
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: true, message: e.message, otpStatus: false, emailStatus: false });
            }
            if (e.errorCode === http.ErrorCode.InvalidInput || e.errorCode === http.ErrorCode.CodeError) {
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: false, emailStatus: false });
                const data = { ...verifyData, errorStatus: true, successStatus: false, message: e.message };
                setVerifyData(data);
                getVerificationPhoto(data);
            } else if (e?.errorCode === http.ErrorCode.ResourceNotExist) {
                setVerifyData({ ...verifyData, errorStatus: false });
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: true, otpStatus: false, emailStatus: false, message: e.message });
            } else if (e?.errorCode === http.ErrorCode.SchemaInvalid) {
                setVerifyData({ ...verifyData, errorStatus: false });
                setIsPasswordValidate({ ...isPasswordValidate, userNameStatus: true, otpStatus: false, emailStatus: true, message: e.message });
            }
            throw e;
        }).finally(() => {
            $$.loading(false);
        });
    };

    const handleVoicePlay = () => {
        if (verifyData.playUrl) {
            setVerifyData({ ...verifyData, playUrl: null });
        }
        $$.loading(true);
        baseService.getVerificationVoice(verifyData.id).then(res => {
            const playUrl = `data:audio/webm;base64,${res.detail}`;
            setVerifyData({ ...verifyData, playUrl });
        }).catch(e => {
            throw e;
        }).finally(() => {
            $$.loading(false);
        });
    };
    return (
        <div className="changepassword">
            {isFirstPage ?
                <>
                    <span className='top-title'>{i18n.get('CIS_ChangePassword_TopTitle_Entry')}</span>
                    <Icon className='fia-info-circle' data-tooltip={true} aria-label={i18n.get('CIS_ChangePassword_SecondStep_Description_Captcha_Tooltip_Entry')}></Icon>
                    {isSendOTP &&
                        <div className='change-desc'>{i18n.get('CIS_ChangePassword_SecondStep_Description_Entry')}</div>}
                </> :
                <>
                    <div className='backTextIcon'>
                        <Icon className='fia-arrow-left' id="icon-back" onClick={handleBack}></Icon>
                        <div className='top-title'>{i18n.get('CIS_ChangePassword_TopTitle_Entry')}</div>
                    </div>

                    <div className='change-desc'>{i18n.get('CIS_ChangePassword_FirstStep_Description_Entry')}</div>
                    <div className='password-rule'>{i18n.get('CIS_ChangePassword_PasswordRule_Title_Message')}</div>
                    <ul>
                        <li className="password-rule-items">{i18n.get('CIS_ChangePassword_PasswordRule_Item_Lowercase_Entry')}</li>
                        <li className="password-rule-items">{i18n.get('CIS_ChangePassword_PasswordRule_Item_Uppercase_Entry')}</li>
                        <li className="password-rule-items">{i18n.get('CIS_ChangePassword_PasswordRule_Item_Numbers_Entry')}</li>
                        <li className="password-rule-items">{i18n.get('CIS_ChangePassword_PasswordRule_Item_Symbols_Entry')}
                            <div>{i18n.get('CIS_ChangePassword_PasswordRule_Item_SymbolsEg_Entry')}</div>
                        </li>
                    </ul>
                    <ul style={{ padding: 0 }}>
                        <li className='password-rule-content'>{i18n.get('CIS_ChangePassword_PasswordRule_Content_NotContain_Entry')}</li>
                        <li className='password-rule-content'>{i18n.get('CIS_ChangePassword_PasswordRule_Content_ReUse_Entry')}</li>
                    </ul>
                </>
            }

            <Form >
                <Row label={i18n.get('CIS_ChangePassword_UserName_Title_Entry')} className="username-row">
                    <Input
                        type="text"
                        value={password.userName || decodeURIComponent(sub)}
                        attrs={{ "aria-labelledby": Form.formlabel, "style": "font-size:20px;color:#000" }}
                        id="inputUsername"
                        onChange={value => handleInputChange('username', value)}
                        disabled={sub || !isFirstPage ? true : false}
                        onBlur={userNameInputBlur}
                    />
                    <R.ValidationFaker of={"#inputUsername"} valid={!isPasswordValidate.userNameStatus} message={isPasswordValidate.message} />
                </Row>
                <div className='div-block-container' style={{ display: `${isFirstPage ? 'block' : 'none'}` }}>
                    <Row>
                        <CISInput
                            classNames={'human-verification'}
                            iconClassName={'fia-shield-halved'}
                            placeholder={i18n.get('CIS_HumanVerification_Input_PlaceHolder_Entry')}
                            type={'text'}
                            hasButton
                            isChangeRed={verifyData?.errorStatus}
                            value={verifyData?.code}
                            onChange={value => handleInputChange('verify', value)}
                            id="VerificationCode"
                        />
                        {verifyData?.successStatus && !verifyData?.errorStatus && <div className='verify-success-desc'>{i18n.get('CIS_HumanVerification_Input_SuccessDescription_Message')}</div>}
                        <R.ValidationFaker of={"#VerificationCode"} valid={!verifyData?.errorStatus} message={verifyData?.message} />
                        <R.Button
                            classify="info"
                            icon="fia-arrow-right-subnav"
                            className="reverse"
                            text={i18n.get('CIS_ChangePassword_CheckCaptChaButton_Entry')}
                            attrs={{ 'style': 'border-radius: 8px; font-size: 18px ;height:39px; position: absolute;top: 0;right: 12px;' }}
                            onClick={checkCaptchaCode}
                            disabled={isDisabled}
                        />
                    </Row>
                    <Row>
                        <div className='verify-pic-container'>
                            {verifyData?.photo && <img src={`data:image/png;base64,${verifyData.photo}`} />}
                        </div>
                        <div className='play-refresh-container'>
                            <Icon icon='fia-refresh' className='refresh' onClick={refreshClick} tooltip='Refresh' />
                            <Icon icon='fia-volume' className='play-voice' onClick={handleVoicePlay} tooltip='Audio' />
                            {
                                verifyData?.playUrl &&
                                <audio autoPlay>
                                    <source src={verifyData.playUrl} />
                                </audio>
                            }
                        </div>
                    </Row>
                    <Row ref={emailRef}>
                        <CISInput
                            classNames={'send-otp'}
                            iconClassName={'fia-email-envelope'}
                            hasButton
                            type={'text'}
                            value={password?.email}
                            onChange={value => handleInputChange('email', value)}
                            isChangeRed={isPasswordValidate?.emailStatus}
                            id="inputEmail"
                            disabled
                        />
                        <R.ValidationFaker of={"#inputEmail"} valid={!isPasswordValidate?.emailStatus} message={isPasswordValidate?.message} />
                        {isResendIn ? <R.Button
                            classify="info"
                            icon="fia-arrow-right-subnav"
                            className="reverse"
                            text={isResend ? i18n.get('CIS_ChangePassword_ReSendOTPButton_Message') : i18n.get('CIS_ChangePassword_SendOTPButton_Message')}
                            attrs={{ 'style': 'border-radius: 8px; font-size: 18px ;height:39px; position: absolute;top: 0;right: 12px; cursor:pointer; z-index:100;' }}
                            onClick={handleSendCode}
                            disabled={isDisabled || !verifyData?.successStatus}
                        /> : <LodingButton
                            text={i18n.get('CIS_Home_Singpass_EmailOTP_ResendIn_Entry', timer)}
                        />}
                    </Row>

                    <Row>
                        <CISInput
                            classNames={'login-by-otp'}
                            iconClassName={'fia-lock'}
                            placeholder={i18n.get('CIS_ChangePassword_EmailOTP_Placeholder_Message')}
                            type={'password'}
                            value={password?.otpCode}
                            isChangeRed={isPasswordValidate?.otpStatus}
                            onChange={value => handleInputChange('otp', value)}
                            id="inputOtp"
                        />
                        <R.ValidationFaker of={"#inputOtp"} valid={!isPasswordValidate?.otpStatus} message={isPasswordValidate?.message} />
                    </Row>
                </div>
                <div className='div-block-container' style={{ display: `${isFirstPage ? 'none' : 'block'}` }}>
                    <Row>
                        <CISInput
                            id='enterPassword'
                            type={'password'}
                            iconClassName={'fia-lock'}
                            isChangeRed={isPasswordValidate?.firstStatus}
                            placeholder={i18n.get('CIS_ChangePassword_EnterPassword_Input_Placeholder_Entry')}
                            onChange={(value) => handleInputChange('enter', value)}
                            value={password?.enterPassword}
                        ></CISInput>
                        <R.ValidationFaker of={"#enterPassword"} valid={!isPasswordValidate?.firstStatus} message={isPasswordValidate?.message} />

                    </Row>
                    <Row>
                        <CISInput
                            classNames={'re-enter-password'}
                            type={'password'}
                            iconClassName={'fia-lock'}
                            isChangeRed={isPasswordValidate?.secondStatus}
                            placeholder={i18n.get('CIS_ChangePassword_ReEnterPassword_Input_Placeholder_Entry')}
                            onChange={(value) => handleInputChange('reEnter', value)}
                            value={password?.reEnterPassword}
                            onBlur={() => changepasswordInputBlur()}
                            id='reEnterPassword'
                        ></CISInput>
                        <R.ValidationFaker of={"#reEnterPassword"} valid={!isPasswordValidate?.secondStatus} message={isPasswordValidate?.message} />
                    </Row>
                </div>

                <Row>
                    <R.Button
                        text={loginButtonText}
                        classify='info'
                        block
                        attrs={{ 'style': 'border-radius: 8px; font-size:18px; height: 42px;' }}
                        onClick={() => handleLogin(isFirstPage)}
                        disabled={isFirstPage && (loginDisabled || cookieDisable || !isSendOTP)}
                    />
                </Row>

                {isFirstPage && <div className='changepassword-instruction'>
                    {i18n.get('CIS_ChangePassword_Instruction_Message')}
                </div>}
            </Form>
        </div>
    );
};

export default ChangePassword;